<template>
  <div v-if=msg :class="'alert alert-dismissible fade show alert-' + type" role="alert" style="z-index:9000;">
    <div class="container">
      <div v-html="msg"></div>
      <button @click=clear type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>

<script>

  export default {
    props: ['type', 'msg'],
    methods: {
      clear() {
        this.$store.commit('alert/CLEAR');
      },
    },
  };
</script>




// WEBPACK FOOTER //
// src/components/shared/Alert.vue